import { ExternalUrlGroupsSectionType } from 'app/area/external-url-groups/form/metroline/types';
import { selectorId } from 'app/area/shared/selector-id';
import { DefaultContainerProps } from 'app/infrastructure/redux';
import { ExternalUrlGroupsState } from '../types-store';
import { hasChanges } from './utils/has-changes';

export interface ExternalUrlFormSelectorProps {
  id: number;
  shouldPrompt: boolean;
  section: ExternalUrlGroupsSectionType;
}

type ExternalUrlFormSelectors = { [T in keyof ExternalUrlFormSelectorProps]?:
  (state: ExternalUrlGroupsState, props: DefaultContainerProps) => ExternalUrlFormSelectorProps[T] };

export const selectors: ExternalUrlFormSelectors = {
  shouldPrompt: ({ form }) =>
    hasChanges(form?.externalUrlGroupItem, form?.originalExternalUrlGroupItem),
  id: (_, { params }) => selectorId(params?.id),
  section: (_, { params }) =>
    params?.section || undefined
};
